import { Indicator } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => ( // Вопрос: почему forwardRef?
	<Indicator {...p} {...p.customProps}>
		{p.children}
	</Indicator>
))
